<template>
  <div class="relative w-screen h-screen overflow-hidden bg-slate-100 flex flex-column items-center justify-center">
    <div
        class="w-64 md:w-96 h-96 md:h-full bg-green-600 bg-opacity-50 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"></div>
    <div
        class="w-96 h-full bg-red-600 bg-opacity-40 absolute -bottom-96 right-64 rounded-full pointer-events-none -rotate-45 transform"></div>
    <div class="flex items-center justify-center overflow-auto h-screen xl:w-full xl:justify-evenly">
      <SliderContainer/>
      <LoginForm/>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/components/auth/components/LoginForm.vue";
import SliderContainer from "@/components/auth/components/SliderContainer.vue";

export default {
  name: "LoginPage",
  components: {LoginForm, SliderContainer},
};
</script>